import { createSlice } from '@reduxjs/toolkit'
import hit from 'src/services/manager'
import { setToast } from 'src/redux/toast'

const initialState = {
    list: []
}

const usersSlice = createSlice({
    name: "users",
    initialState,
    reducers: {
        setList: (state, action) => {
            state.list = action.payload
        }
    }
})

export const { setList } = usersSlice.actions

export const getAllUsers = () => {
    return async (dispatch) => {
        try {
            let res = await hit("/admins/users", "get")
            if (!res?.err) {
                dispatch(setList(res.data))
            } else {
                dispatch(setToast({ show: true, message: res?.msg || "Failed to load users", severity: "error" }))
            }
        } catch (err) {
            dispatch(setToast({ show: true, message: "Failed to load users", severity: "error" }))
        }
    }
}

export default usersSlice.reducer